import handleRedirect from '../utils/redirect';
import { hasStoredSession } from '../utils/session';

/**
 * Keeps signed-in learners out of the public signup pages by handing them to the
 * learner portal, using the same access-token exchange as the rest of the app.
 *
 * Opt a route in with `meta.middleware.redirectIfAuthenticated: true`.
 *
 * This previously did `next({ name: 'memberDashboard.classroom.overview' })`.
 * That is now a dead end: router/index.js turns any /dashboard navigation into a
 * full page load, RedirectDashboardToLearnerPortal 302s it to the portal with NO
 * token, and the learner arrives without a session — so the journey stops at the
 * portal's login. handleRedirect (utils/redirect.js) exchanges the session for a
 * portal URL properly, and falls back to the portal's own dispatch route if that
 * fails.
 */

export default function (router) {
    router.beforeEach((to, from, next) => {
        if (! _.get(to, 'meta.middleware.redirectIfAuthenticated', false)) {
            return next();
        }

        if (! hasStoredSession()) {
            return next();
        }

        /**
         * Abort before the page renders. handleRedirect does a full-page
         * transition, and letting the signup page mount meanwhile would flash it
         * on the way out.
         *
         * Not awaited on purpose: a guard cannot hold up navigation past next(),
         * and handleRedirect always ends in a window.location replacement —
         * including its own fallback — so the learner is never left nowhere.
         */
        next(false);

        handleRedirect('/');
    });
}
